export default {
      id: "ic_insufficient_funds-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_insufficient_funds-usage",
      toString: function () {
        return this.url;
      }
    }